import React, { useEffect, useRef, useState } from "react";
// import "primereact/resources/themes/tailwind-light/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
import { ListBox } from 'primereact/listbox';
import { SelectButton } from 'primereact/selectbutton';
import { InputMask } from "primereact/inputmask";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from 'primereact/tree';
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ColorPicker } from 'primereact/colorpicker';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import useLocalStorage from "src/hooks/useLocalStorage";
import strftime from "strftime";
import { Checkbox } from 'primereact/checkbox';
import { Panel } from 'primereact/panel';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { BlockUI } from 'primereact/blockui';

function CarrierShare() {
  const [resultR, setResult] = useState({});
  const [datex, setDate] = useState(new Date());
  const [data, setData] = useState([{ name: "Loading ......" }]);
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    let isMounted = true;
    let x = { date: datex };
    setBlocked(true);
    performanceManagementService.RightelCarrierShare(x).then((result) => {
      if (isMounted) {
        let kpi = Object.keys(result.data).map(p => ({ "name": p }));
        setResult(result.data);
        setData(result.data);
        // console.log(result.data[kpi[0].name]);
        setBlocked(false);
      }
    });
    return () => { isMounted = false };
  }, [datex]);

  const exportExcel = () => {
    
    import('xlsx').then((xlsx) => {
      // setBlocked(true);
      const workbook = xlsx.utils.book_new();
      const worksheet = xlsx.utils.json_to_sheet(resultR);
      xlsx.utils.book_append_sheet(workbook, worksheet, "CarrierShare");
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, "CarrierShare");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then(async (module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        await module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        console.log("set blocked");
        // setBlocked(false);
      }
    });
  };
  const header = (
    <div className="flex align-items-center justify-content-end gap-2">
      <div className="p-inputgroup"> <Calendar value={datex} onChange={(e) => { setDate(e.value); console.log(e.value); }} dateFormat="yy-mm-dd" showIcon /></div>
      <div className="p-inputgroup"><Button type="button" icon="pi pi-file-excel" severity="success" rounded data-pr-tooltip="XLS" onClick={exportExcel} /></div>
    </div>
  );
  return (
    <div>
      <div className="card">
        <DataTable loading={blocked} sortMode="multiple" size="small" paginator rows={50} rowsPerPageOptions={[50, 100]} value={data} header={header} tableStyle={{ minWidth: '50rem' }}>
          {Object.keys(data[0]).map((col, i) => (
            // console.log(col)
            <Column key={col} sortable field={col} header={col} />
          ))}
        </DataTable>
      </div>
    </div>
  );
}

export default CarrierShare;




